import React, { useState } from 'react'

export default function Header() {
    const [activity, setactivity] = useState("");
    const [list, setlist] = useState([]);

    const addTodo= () => {
        // setlist([...list, activity])
        setlist((list) => {
            let updated = [...list, activity]
            setactivity('')
            console.log(updated)
            return updated;
        })
    }
    const removelist=(index)=>{
        const updatedlist = list.filter((element, id) =>{
            return index !== id;
        })
        setlist(updatedlist)
    }
    const removeAll = () =>{
        setlist([])
    }

  return (
    <>
    <div className='container'>
        <div className='todo'>TODO LIST</div>

        <input type="text" placeholder='Add ToDO' value={activity} onChange={(event) => setactivity(event.target.value)}/>

        <button onClick={addTodo}>Add ToDo</button>

        <p className='listHeading'>Here your ToDo list...</p>
        {list!==[] && list.map((list, index) =>{
            return (
                <>
                <p key ={index}>
                    <div>{list}</div>
                    <button onClick={() => removelist (index) }>Remove</button>
                </p>
                </>
            )
        })}

    {list.length >=2 && <button onClick={removeAll}>Remove All</button>}

    <div className='footer'>make by @nuj... &#169;</div>
    </div>
        
    </>
  )
}
